// Web3Forms access key — single source of truth for all site forms.
// Get/replace this at https://web3forms.com (tied to info@buildlabconsulting.com).
export const WEB3FORMS_ACCESS_KEY = '1a0283d0-1fd1-4af1-ac8d-3b5a1002d0f5';
